import { BaseURl } from "./BaseApiUrl";



//https://testcockpit.p2k.in/api/reports/repEnquiryCurrentStatus/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&isPagination=1&pageNo=1&perPageRec=200&fromDate=2026-04-01&toDate=2026-04-03

export const getEnquiryCurrentStatusRepAPIURL = BaseURl + "reports/repEnquiryCurrentStatus/v1/";